import { Injectable } from '@angular/core';
import { Environment, ApplicationType } from './environment';

declare let environment: Environment;
const defaultFeatureFlags = {
  onBoardLimitedRelease: true,
  allowEditReferenceData: false,
  cms1500ActivationDate: '',
  parDmeEnabled: false,
  parMtgEnabled: false,
};

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  public isExternalSite: boolean;

  constructor() {
    const env: Environment = this.getEnvironment();
    if (!env.featureFlags) {
      env.featureFlags = defaultFeatureFlags;
    } else {
      for (const featureName in defaultFeatureFlags) {
        if (env.featureFlags[featureName] == null) {
          env[featureName] = defaultFeatureFlags[featureName];
        }
      }
    }
    this.isExternalSite = env.appType === ApplicationType.external;
  }

  getEnvironment(): Environment {
    return environment;
  }
}
